import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { HStack, VStack } from '@saucelabs/sl-component-grid';
import { Typography } from '@saucelabs/ds-typography';

import { TESTING_TYPES, REAL_DEVICE, VIRTUAL_DEVICE } from '../../constants';
import { amountSeparator } from '../../utils/numbers';
import { Checkbox } from '../Layout/Checkbox';
import { Subscription } from '../../records/Subscription';
import Styles from './SubscriptionCheckbox.styles';

export interface Props {
  checked: boolean;
  onChange: () => void;
  subscription: Subscription;
}

const getCoverage = (subscription: Subscription) => {
  // eslint-disable-next-line camelcase
  const { testing_type: testingType, device_type: deviceType } = subscription.plan;
  if (testingType === TESTING_TYPES.LIVE) {
    return 'Live Testing';
  }
  if (deviceType === REAL_DEVICE) {
    return 'Real Device';
  }
  if (deviceType === VIRTUAL_DEVICE) {
    return 'Virtual Device';
  }
  if (testingType === TESTING_TYPES.MOBILE_QUALITY) {
    return 'Mobile Beta Testing';
  }
  if (testingType === TESTING_TYPES.API_TESTING) {
    return 'API Testing';
  }
  throw Error(`unknown coverage ${testingType} ${deviceType as string}`);
};

const context = classNames.bind(Styles);

export const SubscriptionCheckbox: React.FC<Props> = ({
  checked,
  onChange,
  subscription,
}) => (
  <div className={context('subscription-box', 'padding2', { checked })}>
    <VStack gap={1}>
      <Typography
        className="my-0"
        disableSpacing
        variant="heading-4"
      >
        {subscription.plan.displayName()}
      </Typography>
      <label>
        <HStack gap={1}>
          <Checkbox
            checked={checked}
            onChange={onChange}
            value={subscription.id}
          />
          <div className={context({ 'text-red-1000': checked })}>
            <div className="font-bold">
              {(subscription.plan.isUsage()) ? (
                'Cancel Usage plan' // FIXME: Change text content for "usage" plan, when design is ready
              ) : (
                `Cancel ${getCoverage(subscription)} Coverage`
              )}
            </div>
            <div>{`Subscription till ${subscription.displayNextBillDate()}`}</div>
          </div>
        </HStack>
      </label>
    </VStack>
    <HStack alignItems="baseline">
      <Typography
        className="my-0"
        disableSpacing
        variant="heading-3"
      >
        {amountSeparator(subscription.getMonthlyPrice())}
      </Typography>
      <span>&nbsp;/ month</span>
    </HStack>
  </div>
);

SubscriptionCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription).isRequired,
};
